import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

/**
 * 스와이프 컴포넌트
 * @returns JSX.Element
 */

const SwiperWrapper = () => {
	return (
		<section className="main-visual main-section">
			<Swiper
				modules={[Navigation, Pagination]}
				spaceBetween={0}
				slidesPerView={1}
				navigation={{
					nextEl: '.swiper-control .swiper-button-next',
					prevEl: '.swiper-control .swiper-button-prev'
				}}
				pagination={{
					el: '.swiper-control .swiper-pagination',
					type: 'fraction',
					clickable: true
				}}>
				<SwiperSlide className="main-visual-wrap visual1">
					<div className="main-visual-inner">
						<div className="main-visual-text">
							<strong className="main-visual-title">
								스타트업과 성장기업을 위한 <br />
								올인원 비즈니스웨어 플랫폼, <span className="font-bold">스텔라</span>
							</strong>
							<div className="main-visual-desc">
								<p>스타트업, 성장기업을 위한 전용 비즈니스 플랫폼 !</p>
								<p>회계처리 자동화, 인사 및 급여 관리, 세금신고는 기본,</p>
								<p>경영진을 위한 필수 경영정보 실시간 제공,</p>
								<p>투자 유치 연계부터 주주관리까지</p>
								<p className="font-bold">스텔라는 스타트업, 성장기업을 위한 맞춤형 ERP입니다</p>
							</div>
						</div>
						<div className="main-visual-img">
							<i></i>
						</div>
					</div>
				</SwiperSlide>
				<SwiperSlide className="main-visual-wrap visual2">
					<div className="main-visual-inner">
						<div className="main-visual-text">
							<strong className="main-visual-title">
								사업의 출발부터 도약까지 <br />
								기업의 성장을 지원하는 <br />
								가치혁신파트너,<span className="font-bold">스텔라</span>
							</strong>
							<div className="main-visual-desc">
								<p>스타트업과 성장기업이 필요로 하는 핵심 기능을 한곳에 모은 혁신적인 솔루션!</p>
								<p>시작하는 작은 기업부터, 미래를 준비하는 성장 기업은 물론 중견 기업까지</p>
								<p className="font-bold">스텔라는 기업의 시작·성장·미래에 필수적인 기업 솔루션입니다.</p>
							</div>
						</div>
						<div className="main-visual-img">
							<div className="light-house">
								<div className="glow-shine">
									<div className="glow-shine-5 shine-circle"></div>
									<div className="glow-shine-4 shine-circle"></div>
									<div className="glow-shine-3 shine-circle"></div>
									<div className="glow-shine-1 shine-circle"></div>
									<div className="glow-shine-2 shine-circle"></div>
								</div>
							</div>
						</div>
					</div>
				</SwiperSlide>
			</Swiper>
			<div className="swiper-control">
				<div className="swiper-navigation">
					<div className="swiper-button-prev"></div>
					<div className="swiper-button-next"></div>
				</div>
				<div className="swiper-pagination"></div>
			</div>
		</section>
	);
};

export default SwiperWrapper;
